module.exports = __webpack_public_path__ + "static/media/3DPPA41.f3798420.jpg";